import React from 'react';
import {
  FormControl,
  FormLabel,
  GridItem,
  NumberInput,
  NumberInputField,
} from '@chakra-ui/react';
import { Select as ChakraSelect } from '@chakra-ui/react';
import CreatableSelect from 'react-select/creatable';

const VenueForm = ({ formData, handleChange, cities, venues }) => {
  return (
    <>
      <GridItem>
        <FormControl>
          <FormLabel>Cities</FormLabel>
          <CreatableSelect
            isMulti
            value={formData.locations?.cities?.map(city => ({ label: city, value: city })) || []}
            onChange={(selected) => {
              const cities = selected ? selected.map(option => option.value) : [];
              handleChange('locations', { ...formData.locations, cities });
            }}
            placeholder="Select or create cities"
          />
        </FormControl>
      </GridItem>

      <GridItem>
        <FormControl>
          <FormLabel>Venues</FormLabel>
          <CreatableSelect
            isMulti
            value={formData.locations?.venues?.map(venue => ({ label: venue, value: venue })) || []}
            onChange={(selected) => {
              const venues = selected ? selected.map(option => option.value) : [];
              handleChange('locations', { ...formData.locations, venues });
            }}
            placeholder="Select or create venues"
          />
        </FormControl>
      </GridItem>



      <GridItem>
        <FormControl>
          <FormLabel>Room Count</FormLabel>
          <NumberInput min={0} value={formData.roomCount || 0} onChange={(valueString) => {
            const value = Number(valueString);
            console.log('Room Count Changed:', value);
            handleChange('roomCount', value);
          }}>
            <NumberInputField
              placeholder="Enter room count"
            />
          </NumberInput>
        </FormControl>
      </GridItem>

      <GridItem>
        <FormControl>
          <FormLabel>Residence Guest Count</FormLabel>
          <NumberInput min={0} value={formData.residenceGuestCount || 0} onChange={(valueString) => {
            const value = Number(valueString);
            console.log('Residence Guest Count Changed:', value);
            handleChange('residenceGuestCount', value);
          }}>
            <NumberInputField
              placeholder="Enter residence guest count"
            />
          </NumberInput>
        </FormControl>
      </GridItem>
    </>
  );
};

export default VenueForm;
